import { UtmInput } from 'src/gqlReactTypings.generated.d';

const STORAGE_KEY = 'tablerun-utm';

const UTM_KEYS: ReadonlyArray<keyof UtmInput> = [
  'source',
  'medium',
  'campaign',
  'term',
  'content',
  'target',
  'cuisine',
  'impactClickId',
];

const utmKeyToQueryParam: Record<keyof UtmInput, string> = {
  source: 'utm_source',
  medium: 'utm_medium',
  campaign: 'utm_campaign',
  term: 'utm_term',
  content: 'utm_content',
  target: 'utm_target',
  cuisine: 'utm_cuisine',
  impactClickId: 'im_ref',
};

/**
 * Capture UTM query params from the current URL and persist them in
 * sessionStorage so subsequent navigations (marketing → signup) can include
 * them in the signup mutation. Idempotent — only captures fields that are
 * present in the URL; existing stored UTM values survive a no-UTM revisit.
 */
export const captureUtmFromUrlIntoSession = (): void => {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  const captured: Partial<UtmInput> = {};
  UTM_KEYS.forEach((key) => {
    const queryParam = utmKeyToQueryParam[key];
    const value = params.get(queryParam);
    if (value) {
      captured[key] = value;
    }
  });
  if (Object.keys(captured).length === 0) return;
  const existing = readUtmFromSession();
  const merged: UtmInput = { ...existing, ...captured };
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
};

export const readUtmFromSession = (): UtmInput | null => {
  if (typeof window === 'undefined') return null;
  const raw = window.sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as UtmInput;
  } catch {
    return null;
  }
};
